import { AxiosResponse } from "axios";
import { BACKEND_ENDPOINT, STATUS_MODULOS } from "../utils/constants";

export const getStatusModulos = (version ,aplicacion, apiRequest: any) => {
    return new Promise<AxiosResponse>((resolve, reject) => {
        const url = BACKEND_ENDPOINT() + STATUS_MODULOS;
        const method = 'POST';
        const data = {
            version,
            aplicacion,
        }
        const options = {
            method,
            url,
            data
        }
        apiRequest(options)
        .then((response : AxiosResponse) => resolve(response.data))
        .catch((error : any) => reject(error));
    });
}